import { Injectable } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import {LocalStorageService} from './local-storage.service'

@Injectable({
  providedIn: 'root'
})
export class NavigateService {

  constructor(
      private router: Router,
      private route: ActivatedRoute,
      private localStorageService: LocalStorageService
  ) { }

  goTo( page, params?, subpage? ) {

    // const theme = 'desktop'
    const theme = this.localStorageService.getTheme()
    // let finalPage = 'desktop/d/' + page
    let finalPage = page
    if ( theme === 'covid' ) {
      finalPage = 'covid/' + page
    } else if ( theme === 'scanQrCode' ) {
      finalPage = 'scan/' + page
    } else if ( theme === 'debug' ) {
      finalPage = 'debug/' + page
    }  else if ( theme === 'desktop' && page !== 'endpoints' && page !== 'sso') {
      finalPage = 'desktop/d/' + page
    } else if ( theme === 'desktop' ) {
      finalPage = 'desktop/' + page
    }
    return this.router.navigate([ finalPage ], {queryParams: params})
  }

  goToTheme( theme?: string ) {
    if ( !theme ) {
      theme = this.localStorageService.getTheme()
    }
    const applicationId = this.localStorageService.getApplicationId()
    // return this.router.navigate(['desktop/' + applicationId], {queryParams: params})
    if ( theme === 'covid' ) {
      this.router.navigate([ 'covid/' + applicationId ], {queryParams: this.route.snapshot.queryParams})
    } else if ( theme === 'scanQrCode' ) {
      this.router.navigate(['scan/' + applicationId], {queryParams: this.route.snapshot.queryParams})
    } else if ( theme === 'debug' ) {
      this.router.navigate(['debug/' + applicationId], {queryParams: this.route.snapshot.queryParams})
    }
    else if ( theme === 'desktop' ) {
      this.router.navigate(['desktop/' + applicationId], {queryParams: this.route.snapshot.queryParams})
    } else {
      this.goToNotFound()
    }
  }

  goToHome( applicationId?: string ) {    
    let url = '/'
    if ( applicationId ) {
      url += applicationId
    }

    this.router.navigate([url], {queryParams: this.route.snapshot.queryParams})
  }

  goToNotFound() {
    this.router.navigate(['/404'])
  }

  goToLogOut( applicationId?: string ) {
    const queryParams = {}
    if ( applicationId ) {
      queryParams['applicationId'] = applicationId
    }
    this.router.navigate(['/logout'], {queryParams: queryParams})
  }

  goBack() {
    this.router.navigate( ['..'])
  }
}
